import {Injectable} from '@angular/core';

/** Parámetro que fuerza una URL que ninguna caché ha visto. */
const MARCA = 'v';

/**
 * URL a la que navegar para recargar sin que ninguna caché pueda meter baza: la misma ruta
 * con `?v=<sha del build nuevo>`.
 *
 * El `no-cache` de index.html (ver `src/.htaccess`) debería bastar, pero solo llega al
 * navegador en respuestas que este llega a pedir — y se midió que una copia guardada ANTES
 * de que existiera la cabecera se sigue sirviendo sin preguntar nada. Con una URL nueva eso
 * deja de importar, aquí y en cualquier navegador o proxy que se porte mal por el camino.
 */
export function construirUrlDeRecarga(href: string, sha: string): string {
    const url = new URL(href);
    url.searchParams.set(MARCA, sha);
    return url.toString();
}

/**
 * La misma URL sin la marca, o `null` si no la llevaba — así quien llama no toca el historial
 * en balde. La marca es un apaño de transporte: no tiene por qué quedarse en la barra.
 */
export function urlSinMarcaDeRecarga(href: string): string | null {
    const url = new URL(href);
    if (!url.searchParams.has(MARCA)) {
        return null;
    }
    url.searchParams.delete(MARCA);
    return url.toString();
}

/**
 * El contacto con `location`/`history`, detrás de una clase para poder sustituirlo en los
 * tests: una recarga de verdad dentro de Karma se lleva por delante la suite entera.
 */
@Injectable({providedIn: 'root'})
export class RecargadorPagina {

    constructor() {
        this.limpiarMarca();
    }

    /** Recarga pidiendo una URL que ninguna caché puede tener guardada. */
    public recargar(sha: string): void {
        location.replace(construirUrlDeRecarga(location.href, sha));
    }

    /** Borra la marca de la barra de direcciones sin recargar ni navegar. */
    public limpiarMarca(): void {
        const limpia = urlSinMarcaDeRecarga(location.href);
        if (limpia !== null) {
            history.replaceState(history.state, '', limpia);
        }
    }
}
